export default "__VITE_ASSET__BKYbb8Od__"